@switch (state()) {
  @case (ExpandArrowState.Hidden) {
    <ng-container />
  }

  @case (ExpandArrowState.Loading) {
    <span class="spinner" [style.width.px]="diameter()" [style.height.px]="diameter()">
      <mat-spinner [diameter]="diameter()" />
    </span>
  }

  @case (ExpandArrowState.Disabled) {
    <button mat-icon-button [disabled]="true" aria-label="Keine Unterelemente">
      <mat-icon inline>keyboard_arrow_right</mat-icon>
    </button>
  }

  @default {
    <button mat-icon-button [attr.aria-expanded]="isExpanded()" [attr.aria-label]="isExpanded() ? 'Einklappen' : 'Ausklappen'">
      <mat-icon [class.rotate]="isExpanded()" inline>keyboard_arrow_right</mat-icon>
    </button>
  }
}
